import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { AgenticAccesses } from "./accesses.ts";
import { AgenticComponents } from "./components.ts";

const AgenticFilters = {
  gateway: { keys: ["id"] },
  server: { keys: ["id"] },
  agent: { keys: ["id"] },
  annotation: { keys: ["value"] },
  tool: { keys: ["name"] },
} as const satisfies AnyFilterSchema;

export type AgenticFilters = typeof AgenticFilters;

export const AgenticRegistration = Registration({
  accesses: AgenticAccesses,
  category: "resource",
  components: AgenticComponents,
  docs: { install: "agentic-gateway" },
  filters: AgenticFilters,
  // a2a-bridge keeps the protocol's own capitalization
  itemKind: (component) =>
    component === "a2a-bridge" ? "A2A bridge" : component.replace("-", " "),
  label: "Agentic gateway",
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Model_Context_Protocol_logo.svg/3840px-Model_Context_Protocol_logo.svg.png",
  maturity: "ga",
  requestType: "requestable",
  useMapping: [
    { use: "iam_write", component: "server" },
    { use: "auth", component: "gateway" },
  ],
});

registerIntegration("agentic", AgenticRegistration);
